import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MoveSandbox } from '@app/move/sandboxes/move.sandbox';
import { Navigation } from '@app/navigation/enums/navigation.enum';
import { AppUiSandbox } from '@app/ui/sandboxes/ui.sandbox';

@Component({
    selector: 'app-complete-data-energy',
    template: `
        <div class="u-flex-column" [ngSwitch]="moveSandbox.energyComplete$ | async">
            <div class="u-flex-row">
                <div class="u-flex-no-shrink u-margin-right">
                    <img class="__image" src="assets/images/smooved-energy-bulb.png" />
                </div>
                <div>
                    <div class="u-flex-row u-flex-align-items-center u-margin-bottom-half">
                        <h4>{{ 'DASHBOARD.COMPLETE_DATA.ENERGY.TITLE' | translate }}</h4>
                        <app-check-with-background
                            *ngSwitchCase="true"
                            height="20"
                            width="20"
                            class="u-margin-left-half"
                        ></app-check-with-background>
                    </div>
                    <ul class="u-margin-bottom">
                        <li
                            [ngClass]="{ 'u-color-muted': !!(moveSandbox.meterReadingsComplete$ | async) }"
                            class="u-font-size-small u-margin-bottom-half"
                        >
                            {{ 'DASHBOARD.COMPLETE_DATA.ENERGY.METER_READINGS' | translate }}
                        </li>
                        <li [ngClass]="{ 'u-color-muted': !!(moveSandbox.eanCodesComplete$ | async) }" class="u-font-size-small">
                            {{ 'DASHBOARD.COMPLETE_DATA.ENERGY.METER_NUMBERS' | translate }}
                        </li>
                    </ul>
                    <div *ngIf="uiSandbox.tabletPortraitUp$ | async">
                        <app-button type="button" theme="tertiary" *ngSwitchCase="true" [disabled]="true">{{
                            'DASHBOARD.COMPLETE_DATA.ENERGY.CTA.COMPLETE' | translate
                        }}</app-button>
                        <app-button type="button" *ngSwitchCase="false" theme="secondary" [routerLink]="energyLink">{{
                            'DASHBOARD.COMPLETE_DATA.ENERGY.CTA.TITLE' | translate
                        }}</app-button>
                    </div>
                </div>
            </div>
            <div *ngIf="uiSandbox.upToAndIncludingPhoneLandscape$ | async">
                <app-button type="button" theme="tertiary" class="u-w100p" *ngSwitchCase="true" [disabled]="true">{{
                    'DASHBOARD.COMPLETE_DATA.ENERGY.CTA.COMPLETE' | translate
                }}</app-button>
                <app-button type="button" class="u-w100p" *ngSwitchCase="false" theme="secondary" [routerLink]="energyLink">{{
                    'DASHBOARD.COMPLETE_DATA.ENERGY.CTA.TITLE' | translate
                }}</app-button>
            </div>
        </div>
    `,
    styleUrls: ['./complete-data-energy.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompleteDataEnergyComponent {
    public energyLink = `/${Navigation.Complete}/energy`;

    constructor(public moveSandbox: MoveSandbox, public uiSandbox: AppUiSandbox) {}
}
